import React, { useState } from "react";
import { forgotPassword } from "../services/authService";
import { toast } from "react-toastify";
import { MESSAGES } from "../utils/messages";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await forgotPassword(email);
      toast.success(MESSAGES.success.resetLinkSent);
      setSent(true);
    } catch {
      toast.error(MESSAGES.error.failedToSendResetLink);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="bg-white p-6 rounded shadow w-96 text-center">
          <h2 className="text-xl font-semibold mb-4">Check Your Email</h2>
          <p className="text-gray-600 mb-4">
            If an account exists with <strong>{email}</strong>, a password reset
            link has been sent.
          </p>
          <p className="text-sm text-gray-500">
            Didn't receive the email? Check your spam folder or try again.
          </p>
          <a
            href="/login"
            className="mt-4 inline-block text-primary-600 hover:text-primary-500"
          >
            Back to Login
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow w-96">
        <h2 className="text-xl font-semibold mb-4">Forgot Password</h2>
        <p className="text-gray-600 text-sm mb-4">
          Enter your registered email and we'll send you a reset link.
        </p>

        <input
          type="email"
          required
          placeholder="Enter registered email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input-field w-full mb-4"
        />

        <button className="btn-primary w-full" disabled={loading}>
          {loading ? "Sending..." : "Send Reset Link"}
        </button>

        <div className="text-center mt-4">
          <a href="/login" className="text-sm text-primary-600 hover:text-primary-500">
            Back to Login
          </a>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
